/* eslint-disable */

const PUBLIC_USER_FIELDS = `
      id
      user
      name
      profilepicturekey
      backgroundpicturekey
      isDeleted
      messageNotifications
      paymentNotifications
      requestSatusNotifications
      invoiceNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestSatusNotifications
      pushInvoiceNotifications
      createdAt
      updatedAt
      __typename
`;

const PUBLIC_COMPANY_FIELDS = `
      id
      companyUser
      companyName
      companyType
      zipcode
      publicEmail
      publicPhone
      companyWebsite
      bio
      profilepicturekey
      backgroundpicturekey
      town
      state
      emailPrivate
      phonePrivate
      lowRange
      highRange
      lowPrivate
      highPrivate
      isDeleted
      instantPayout
      messageNotifications
      paymentNotifications
      requestNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestNotifications
      isClaimed
      isSeeded
      licenseValidTo
      dataSource
      isBlacklisted
      latitude
      longitude
      borough
      ownerSub
      createdAt
      updatedAt
      __typename
`;

export const getPublicUser =  `
  query GetPublicUser($id: ID!) {
    getUser(id: $id) {${PUBLIC_USER_FIELDS}    }
  }
`;

export const listPublicUsers =  `
  query ListPublicUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {${PUBLIC_USER_FIELDS}      }
      nextToken
      __typename
    }
  }
`;

export const getPublicCompany =  `
  query GetPublicCompany($id: ID!) {
    getCompany(id: $id) {${PUBLIC_COMPANY_FIELDS}    }
  }
`;

export const listPublicCompanies =  `
  query ListPublicCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {${PUBLIC_COMPANY_FIELDS}      }
      nextToken
      __typename
    }
  }
`;

export const publicCompaniesByCompanyUser =  `
  query PublicCompaniesByCompanyUser(
    $companyUser: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesByCompanyUser(
      companyUser: $companyUser
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {${PUBLIC_COMPANY_FIELDS}      }
      nextToken
      __typename
    }
  }
`;

export const publicSchedulesByCompanyID =  `
  query PublicSchedulesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    schedulesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        day
        allDay
        from
        to
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const viewerSchedulesByCompanyID =  `
  query ViewerSchedulesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    schedulesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        day
        companyID
        userID
        __typename
      }
      nextToken
      __typename
    }
  }
`;
